<template>
    <div class="organization-overview rlms-w-100">
        <div class="rlms-flex rlms-items-center rlms-gap-20 rlms-fs-lg rlms-fw-600 rlms-mb-3">
            <RouterLink to="/admin/organizations" class="rlms-flex rlms-items-center">
                <span class="material-symbols-outlined">arrow_back</span>
            </RouterLink> Organization Detail
        </div>

        <div class="pages-topbar rlms-mb-5" style="display: block;">
            <div class="pages-topbar-body">
                <div class="scrollable-content">
                    <ul>
                        <template v-for="(item, i) in sidebarLinks" :key="i">
                            <li :class="{ 'active': isActive(item.to) || item?.childRouteNames?.includes($route.name) }">
                                <RouterLink :to="item.to" :class="{ 'link-active': isActive(item.to) || item?.childRouteNames?.includes($route.name) }" v-if="!item?.hide">
                                    <div class="pages-topbar-link-icon" style="width: 24px;">
                                        <img :src="`${item.icon}`" width="24" height="24" alt="">
                                    </div>
                                    <p class="rlms-fw-500 rlms-us-none">{{ item.name }}
                                    </p>
                                </RouterLink>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <RouterView/>
    </div>
</template>
<script setup>
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { handleError } from '@/utils/handleError';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import OverviewIcon from '@/assets/images/sidebar_blade_88bcc66a.svg'
import LearnersIcon from '@/assets/images/sidebar_blade_15c402e2.svg'
import AdminsIcon from '@/assets/images/sidebar_blade_6ff6c32a.svg'
import GroupsIcon from '@/assets/images/sidebar_blade_8ce6fbe5.svg'
import PurchaseIcon from '@/assets/images/sidebar_blade_30265a60.svg'

const organization = ref(null);
const loader = useLoaderStore();

const route = useRoute();

const organizationid = route.params.organization;

const isActive = (path) => {
    return route.path === path
}

// Define links with icons
const sidebarLinks = [
    {
        name: 'Overview',
        icon: OverviewIcon,
        to: `/admin/organizations/${organizationid}`,
    },
    {
        name: 'Learners',
        icon: LearnersIcon,
        to: `/admin/organizations/${organizationid}/learners`,
        childRouteNames: ['AdminOrgLearnerDetail'],
    },
    {
        name: 'Administrators',
        icon: AdminsIcon,
        to: `/admin/organizations/${organizationid}/administrator`,
    },
    {
        name: 'Groups',
        icon: GroupsIcon,
        to: `/admin/organizations/${organizationid}/group`,
        childRouteNames: ['AdminOrgGroupDetail']
    },
    {
        name: 'Purchase History',
        icon: PurchaseIcon,
        to: `/admin/organizations/${organizationid}/purchase-history`,
    },
];

const getData = async () => {
    try {
        loader.show();

        const { data } = await api.get(`admin/organizations/${organizationid}`);

        organization.value = data?.data ?? null;

    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

// const loading = computed(() => {
//     return loader.loading;
// });

onMounted(async () => await getData());

</script>